import React from "react";
import { connect } from "react-redux";
import DynamicTabwiseTable from "../../components/dynamicscreens/DynamicTabwiseTable";
import { areYouSureMsg, changeActive, convertEnquiryMsg, convertSuccessFullyMsg, convertTextButtonMsg, enquiryAlreadyConvertedMsg, noInternetMsg, selectAtleastOneEnquiryMsg, selectOneRecordOnlyMsg, serverMsg, statusFailedMsg, statusmsg } from "../../config/messageconstant";
import { OutletEnquiryJson } from "../../DynamicFormsJson/MastersJSON/outletEnquiry";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { getEnquiryMasterDataByDateAndStatus } from "../../Slice/enquiryMaster.slice";
import { OutletAdvanceEnquiryColumns, OutletEnquiryColumns } from "../../tableColumns/table-columns";
import { getCurrentDate } from "../../utils/dateFormat";
import { apiGet, apiPost } from "../../utils/api_service";
import { Grid, Paper } from "@mui/material";
import { ButtonCompo } from "../../components/Comman/Button";
import ConvertEnquiryPopUp from "./ConvertEnquiryPopUp";
import endpoint from "../../config/endpoints";

class OutletEnquiryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: 0,
            isLog: true,
            selectedRows: {},
            searchData: {},
            convertEnquiryFlag: false,
            dataShowFlag: null,
            isShowAdvancedEnquirymaster: 0,
            dynamicMasterData: {
                addEnquiresList: this.props.enquiryMasterList?.enquiryMaster?.addedEnquiries,
                allocatedVisitedEnquiries: this.props.enquiryMasterList?.enquiryMaster?.allocatedVisitedEnquiries,
                allocatedUnvisitedEnquiries: this.props.enquiryMasterList?.enquiryMaster?.allocatedUnvisitedEnquiries,
            },
            tabList: [
                {
                    label: OutletEnquiryJson.tab1Label,
                    searchList: OutletEnquiryJson.searchList,
                    allyProps: 0,
                    columns: OutletEnquiryColumns,
                    showExcelDownload: false,
                    isActionColActive: true,
                    value: "addEnquiresList",
                    showView: true,
                },
                {
                    label: OutletEnquiryJson.tab2Label,
                    searchList: OutletEnquiryJson.searchList,
                    allyProps: 1,
                    columns: OutletEnquiryColumns,
                    showExcelDownload: false,
                    isActionColActive: true,
                    value: "allocatedVisitedEnquiries",
                    showView: true,
                },
                {
                    label: OutletEnquiryJson.tab3Label,
                    searchList: OutletEnquiryJson.searchList,
                    allyProps: 2,
                    columns: OutletEnquiryColumns,
                    showExcelDownload: false,
                    isActionColActive: true,
                    value: "allocatedUnvisitedEnquiries",
                    showView: true,
                },
            ],
        };
    }

    componentDidMount() {

        const formData = localStorage.getItem("formData");

        if (formData == null) {
            this.setState({
                dataShowFlag: 0,
            });
            this.getTableData();
        } else {
            this.setState({
                dataShowFlag: 1,
            });
        }

        const isShowAdvancedEnquirymaster = localStorage.getItem("isShowAdvanceEnquiryMaster") ?? 0

        this.setState({ isShowAdvancedEnquirymaster });

        if (isShowAdvancedEnquirymaster == 1) {
            this.setState((prevState) => ({
                tabList: prevState.tabList.map((tab) => ({
                    ...tab,
                    columns: OutletAdvanceEnquiryColumns,
                })),
            }));
        }
    }

    componentWillReceiveProps(nextProps) {

        if (this.props.enquiryMasterList !== nextProps.enquiryMasterList) {
            if (this.props.enquiryMasterList?.enquiryMaster !== nextProps.enquiryMasterList?.enquiryMaster) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        allocatedUnvisitedEnquiries: nextProps.enquiryMasterList?.enquiryMaster?.allocatedUnvisitedEnquiries,
                        allocatedVisitedEnquiries: nextProps.enquiryMasterList?.enquiryMaster?.allocatedVisitedEnquiries,
                        addEnquiresList: nextProps.enquiryMasterList?.enquiryMaster?.addedEnquiries,
                    },
                });
            }
        }
    }

    getTabValue = (rowValue) => {
        this.setState({
            tabValue: rowValue == 0 ? 1 : 0,
        });
    };

    handleSelectionChangeNew = (data) => {
        this.setState({
            selectedRows: {
                0: data.addEnquiresList || [],
                1: data.allocatedVisitedEnquiries || [],
                2: data.allocatedUnvisitedEnquiries || [],
            },
        });
    };

    handleChangeNew = (newValue) => {
        this.setState({ tabValue: newValue });
    };

    getTableData = async () => {
        const {
            getEnquiryMasterDataByDateAndStatus,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {

            let fromDate = getCurrentDate();
            let toDate = getCurrentDate();
            let status = 2;

            showLoador({ loador: true });
            await getEnquiryMasterDataByDateAndStatus({ fromDate, toDate, status }).then(({ success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    onChangeStatus = async (rowData) => {
        const { showLoador, showNotification, enquiryMasterList } = this.props;
        const { searchData, isShowAdvancedEnquirymaster } = this.state;

        const { enquiryMaster } = enquiryMasterList;

        const rowDataId = isShowAdvancedEnquirymaster == 1 ? rowData?.id : rowData;

        const matched = [
            ...(enquiryMaster?.addedEnquiries ?? []),
            ...(enquiryMaster?.allocatedUnvisitedEnquiries ?? []),
            ...(enquiryMaster?.allocatedVisitedEnquiries ?? []),
        ].find((item) => item.id === rowDataId) ?? null;

        const status = matched?.isActive == 0 ? 1 : 0;

        swal({
            title: areYouSureMsg,
            text: changeActive,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                await apiPost({
                    url: OutletEnquiryJson.isActiveURL +
                        "?id=" +
                        rowDataId +
                        "&status=" +
                        status,
                }).then(({ data, success }) => {
                    if (success) {
                        showNotification({ msg: statusmsg, severity: "success" });
                        this.onSearchData(searchData);
                    } else {
                        showNotification({ msg: statusFailedMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });
            }
        });
    }

    onSearchData = async (data) => {
        const {
            getEnquiryMasterDataByDateAndStatus,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {
            this.setState({
                searchData: data,
                selectedRows: {
                    0: [],
                    1: [],
                    2: [],
                },
            });
            if (data?.fromDate !== null && data?.toDate !== null && data?.status !== null) {

                let fromDate = data?.fromDate ? data.fromDate : getCurrentDate();
                let toDate = data?.toDate ? data.toDate : getCurrentDate();
                let status = data?.status ?? 2;


                showLoador({ loador: true });
                await getEnquiryMasterDataByDateAndStatus({ fromDate, toDate, status }).then(({ success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });

            } else {
                this.getTableData();
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    toggleConvertDataPopUp = () => {
        this.setState({
            convertEnquiryFlag: false,
        });
    }

    onConvert = () => {
        const { selectedRows, tabValue, searchData } = this.state;
        const { showNotification, showLoador, enquiryMasterList } = this.props;
        const selectedRowIds = selectedRows[tabValue] || [];


        if (selectedRowIds.length > 1) {
            return showNotification({
                msg: selectOneRecordOnlyMsg,
                severity: "error",
            });
        }
        if (selectedRowIds.length == 0) {
            return showNotification({ msg: selectAtleastOneEnquiryMsg, severity: "error" });
        }

        const enquiryMasterData = enquiryMasterList?.enquiryMaster;

        const enquiryMasterListData =
            enquiryMasterData?.allocatedUnvisitedEnquiries?.find((item) => item.id === selectedRowIds[0]) ??
            enquiryMasterData?.allocatedVisitedEnquiries?.find((item) => item.id === selectedRowIds[0]) ??
            null;

        if (enquiryMasterListData?.isConverted == 1) {
            return showNotification({
                msg: enquiryAlreadyConvertedMsg,
                severity: "error",
            });
        }

        let rowId = selectedRowIds[0];

        swal({
            title: areYouSureMsg,
            text: convertEnquiryMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                await apiGet({
                    url: endpoint.enquiryMaster + "/update-convert-status?id=" +
                        rowId +
                        "&status=1",
                }).then(({ data, success }) => {
                    if (success) {
                        showNotification({ msg: convertSuccessFullyMsg, severity: "success" });
                        this.onSearchData(searchData);
                    } else {
                        showNotification({ msg: data.errorMessage || serverMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });

            }
        });
    };
    render() {
        const { enquiryMasterList } = this.props;
        const {
            dynamicMasterData,
            tabList,
            tabValue,
            selectedRows,
            convertEnquiryFlag,
            dataShowFlag,
            isShowAdvancedEnquirymaster,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 2,
                    }}
                    elevation={0}
                >
                    {dataShowFlag !== null && (
                        <>
                            <DynamicTabwiseTable
                                isShowCheckBoxTable={isShowAdvancedEnquirymaster == 0 ? true : false}
                                selection={(selectedRows[tabValue] || [])}
                                onSelectionChangeAtMain={this.handleSelectionChangeNew}
                                handleChangeNew={this.handleChangeNew}
                                dynamicMasterData={dynamicMasterData}
                                rowList={dynamicMasterData}
                                searchList={OutletEnquiryJson.searchList}
                                formPath={OutletEnquiryJson.formPath}
                                screenTitle={OutletEnquiryJson.screenTitle}
                                fieldMeta={OutletEnquiryJson.fieldMeta}
                                showPdfDownload={OutletEnquiryJson.showPdfDownload}
                                showExcelDownload={false}
                                isExcelStaticUrl={false}
                                filterDataExcel={false}
                                pdfFileName={OutletEnquiryJson.pdfFileName}
                                excelFileName={OutletEnquiryJson.excelFileName}
                                showAddButton={OutletEnquiryJson.showAddButton}
                                tableColumnsToFilter={OutletEnquiryJson.tableColumnsToFilter}
                                tableColumns={isShowAdvancedEnquirymaster == 1 ? OutletAdvanceEnquiryColumns : OutletEnquiryColumns}
                                tableData={enquiryMasterList?.enquiryMaster}
                                apiBaseURL={OutletEnquiryJson.apiBaseURL}
                                callApi={false}
                                isActiveURL={OutletEnquiryJson.isActiveURL}
                                openFormPath={OutletEnquiryJson.openFormPath}
                                searchButtonGrid={OutletEnquiryJson.searchButtonGrid}
                                getTableDataById={true}
                                getTableData={this.getTableData}
                                rowStatusTrue={true}
                                rowStatus={this.onChangeStatus}
                                onSearchData={this.onSearchData}
                                tabList={tabList}
                                formPathStatic={false}
                                showHeadEdit={true}
                                staticEdit={false}
                                deleteStaticTrue={false}
                                getTabValue={this.getTabValue}
                                showHeadDelete={false}
                                showPegination={true}
                                showView={true}
                                formPathView={OutletEnquiryJson.formPathView}
                                selectAllFlag={false}
                            />

                            {tabValue != 0 && isShowAdvancedEnquirymaster == 0 && (
                                <Grid container spacing={1}>
                                    <Grid
                                        container
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        sx={{ justifyContent: "flex-end" }}
                                    >
                                        <ButtonCompo
                                            size="medium"
                                            type="submit"
                                            variant="contained"
                                            name={convertTextButtonMsg}
                                            onClick={this.onConvert}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {convertEnquiryFlag && (
                                <ConvertEnquiryPopUp
                                    open={convertEnquiryFlag}
                                    handleCloses={this.toggleConvertDataPopUp}
                                    selectedRows={selectedRows}
                                    tabValue={tabValue}
                                />
                            )}
                        </>
                    )}

                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    enquiryMasterList: state.enquiryMaster,
});
const mapDispatchToProps = {
    getEnquiryMasterDataByDateAndStatus,
    showLoador,
    showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(OutletEnquiryList);
